import { ProductData } from 'components/product/product-create/product-data/ProductData'
import { useEffect, useState } from 'react'

export const ProductDataContainer = ({ sectionRef, productDetail, onChangeForm, errorForm }) => {
    const TIME_DEFAULT = '00:00'
    const [date, setDate] = useState({ start: null, end: null })
    const [time, setTime] = useState({ start: null, end: null })

    const onChangeDateTime = ({ name, value }) => {
        let newItem = {}
        switch (name) {
            case 'start_date':
                newItem = { sale_start: value ? `${value} ${time?.start || TIME_DEFAULT}` : null }
                break
            case 'end_date':
                newItem = { sale_end: value ? `${value} ${time?.start || TIME_DEFAULT}` : null }
                break
            case 'start_time':
                newItem = { sale_start: `${date?.start} ${value || TIME_DEFAULT}` }
                break
            case 'end_time':
                newItem = { sale_end: `${date?.end} ${value || TIME_DEFAULT}` }
                break
            default:
                return
        }
        onChangeForm(newItem)
    }

    useEffect(() => {
        const splitStartSale = productDetail?.sale_start?.split(' ')
        const splitEndSale = productDetail?.sale_end?.split(' ')
        setDate({ start: splitStartSale?.[0] || null, end: splitEndSale?.[0] || null })
        setTime({ start: splitStartSale?.[1] || null, end: splitEndSale?.[1] || null })
    }, [productDetail?.sale_start, productDetail?.sale_end])

    const propsProductData = {
        sectionRef: sectionRef?.product_data,
        productDetail,
        date,
        time,
        onChangeForm,
        errorForm,
        onChangeDateTime,
    }

    return <ProductData {...propsProductData} />
}
